module.exports = __webpack_public_path__ + "static/img/katun05.b353849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun05.jpg
// module id = 8U49
// module chunks = 0